module.exports = __webpack_public_path__ + "img/watermark.3b5a5f79.png";